import { Component, type ErrorInfo, type ReactNode } from 'react'
import { QueryError } from './QueryError'

interface State { error: Error | null }

export class RootErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State { return { error } }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console -- last-resort logging when render tree explodes
    console.error('[RootErrorBoundary]', error, info)
  }

  render() {
    if (this.state.error) return <QueryError error={this.state.error} onRetry={() => this.setState({ error: null })} />
    return this.props.children
  }
}
